import { render, staticRenderFns } from "./centerLeft2.vue?vue&type=template&id=daa34a14&scoped=true"
import script from "./centerLeft2.vue?vue&type=script&lang=js"
export * from "./centerLeft2.vue?vue&type=script&lang=js"
import style0 from "./centerLeft2.vue?vue&type=style&index=0&id=daa34a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa34a14",
  null
  
)

export default component.exports